/** Shared by the table and the Overview drawer so both read dates identically. */
export const DATE_TIME_FORMAT = 'MMM DD, YYYY hh:mmA';

/** Names shown before "+ N more". A count of names, not of rendered lines. */
export const LINKED_RECORD_NAME_LIST_CAP = 8;

export const LINKED_RECORDS_PAGE_SIZE = 20;
